<template>
  <div class="mobile-menu">
    <div class="mobile-menu__menu" @click="onOpenNavMenuHandle">
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="7.5"
          fill="black"
          fill-opacity="0.5"
          stroke="#FFF380"
        />
        <path
          d="M10 27H30M10 12H30M10 19.5H30"
          stroke="#FFF380"
          stroke-width="2"
        />
      </svg>
    </div>

    <transition name="mobile-menu" appear v-if="visible">
      <div class="mobile-menu__mask">
        <div class="mobile-menu__mask-logo">
          <img
            src="@/assets/image/logo/mobileLogo.webp"
            width="128"
            height="54"
            alt="Logo"
          />
        </div>

        <div class="mobile-menu__mask-close" @click="onCloseNavMenuHandle">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="7.5"
              fill="black"
              fill-opacity="0.5"
              stroke="#FFF380"
            />
            <path
              d="M10 15L30.5 25M30.5 15L10 25"
              stroke="#FFF380"
              stroke-width="2"
            />
          </svg>
        </div>
        <div class="mobile-menu__mask-wrapper">
          <div class="mobile-marquee mobile-marquee--banner">
            <div class="mobile-marquee-inner">
              <div class="mobile-marquee-track">
                <div
                  v-for="dup in 2"
                  :key="'mobile-marquee-banner-' + dup"
                  class="mobile-marquee-group"
                  :aria-hidden="dup === 2 ? 'true' : undefined"
                >
                  <img
                    v-for="item in 10"
                    :key="`mobile-banner-${dup}-${item}`"
                    class="mobile-marquee-title"
                    src="@/assets/image/index/banner_footer_title.webp"
                    width="200"
                    height="14"
                    alt="Scrolling footer title strip (decorative)"
                    aria-hidden="true"
                    decoding="async"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-menu__mask-content">
            <div
              class="mobile-menu__mask-row"
              v-for="menu in displayMenuItems"
              :key="menu.menu"
              :aria-current="isMenuItemActive(menu) ? 'page' : undefined"
              @click="onToTargetPage(menu)"
            >
              <span
                class="mobile-menu__mask-label"
                :class="{
                  'mobile-menu__mask-label--active': isMenuItemActive(menu),
                }"
              >
                {{ menu.menu }}
              </span>
            </div>
          </div>

          <div class="mobile-menu__mask-footer">
            <a
              :href="mobileNavLinks.youtube"
              class="mobile-menu__mask-footer--wrap"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="@/assets/image/logo/mobile_nav_youTube.webp"
                alt="YouTube Logo"
                width="32"
                height="22"
              />
            </a>
            <span> / </span>

            <a
              :href="mobileNavLinks.twitterIntent"
              class="mobile-menu__mask-footer--wrap"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="mobileNavCopy.twitterShareAriaLabel"
            >
              <img
                src="@/assets/image/logo/mobile_nav_x.webp"
                alt="X Logo"
                width="22"
                height="22"
              />
            </a>
          </div>
          <div class="mobile-marquee mobile-marquee--streaming">
            <div class="mobile-marquee-inner">
              <div class="mobile-marquee-track">
                <div
                  v-for="dup in 2"
                  :key="'mobile-marquee-banner-' + dup"
                  class="mobile-marquee-group"
                  :aria-hidden="dup === 2 ? 'true' : undefined"
                >
                  <img
                    v-for="item in 10"
                    :key="`mobile-banner-${dup}-${item}`"
                    class="mobile-marquee-title"
                    src="@/assets/image/index/about_footer_title.webp"
                    width="200"
                    height="14"
                    alt="Scrolling footer title strip (decorative)"
                    aria-hidden="true"
                    decoding="async"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  scrollToAnchorById as scrollDomToAnchorById,
  decodeRouteHashAnchorId,
} from "@/utils/mobile-anchor";
import {
  mobileHomeActiveSectionState,
  setMobileHomeActiveSectionAnchorIdImmediate,
  resetMobileHomeActiveSectionAnchor,
} from "@/utils/mobile-home-active-section";
import indexContent from "@/views/data/index-content.json";
import contentVisibility from "@/views/data/content-visibility.json";

export default {
  name: "MobileNav",

  components: {},

  props: {},

  data() {
    const nav = indexContent.pcHeader;
    const labels = nav.navItems.map((n) => n.label);
    return {
      mobileNavCopy: nav.pcHeaderCopy,
      mobileNavLinks: nav.pcHeaderLinks,
      sectionAnchorIds: {
        [labels[0]]: "section-top",
        [labels[1]]: "section-news",
        [labels[2]]: "section-about",
        [labels[3]]: "section-dj",
      },
      visible: false,
      menuItems: [
        { menu: labels[0], name: "Home" },
        { menu: labels[1], name: "Home" },
        { menu: labels[2], name: "Home" },
        { menu: labels[3], name: "Home" },
        { menu: labels[4], name: "Ticket" },
        { menu: labels[5], name: "Streaming" },
        { menu: labels[6], name: "Goods" },
        { menu: labels[7], name: "Attention" },
      ],
    };
  },

  computed: {
    /** 与 PcHeader 共用 content-visibility.json → header */
    displayMenuItems() {
      const h = contentVisibility.header ?? {};
      const showStreaming = h.showStreamingNav !== false;
      const showGoods = h.showGoodsNav !== false;
      return this.menuItems.filter((menu) => {
        if (!showStreaming && menu.name === "Streaming") return false;
        if (!showGoods && menu.name === "Goods") return false;
        return true;
      });
    },
    /** 订阅 observable，保证滚动同步时菜单会重绘 */
    mobileHomeActiveAnchorId() {
      return mobileHomeActiveSectionState.anchorId;
    },
  },

  watch: {
    $route: {
      handler(to) {
        if (to.name !== "Home") {
          resetMobileHomeActiveSectionAnchor();
        }
      },
      immediate: true,
    },
  },

  mounted() {},

  beforeDestroy() {},

  methods: {
    onOpenNavMenuHandle() {
      this.visible = true;
    },
    onCloseNavMenuHandle() {
      this.visible = false;
    },
    /** 与首页 hash 锚点共用：按 section 的 id 平滑滚动 */
    scrollToAnchorById(anchorId) {
      return scrollDomToAnchorById(anchorId);
    },
    /**
     * 当前路由与菜单项是否一致。
     * 首页四项：hash 在滚动结束后会被 index 清空，须结合 mobileHomeActiveSectionState（滚动同步）。
     */
    isMenuItemActive(menu) {
      const route = this.$route;
      if (menu.name !== "Home") {
        return route.name === menu.name;
      }
      if (route.name !== "Home") return false;
      const anchorId = this.sectionAnchorIds[menu.menu];
      if (!anchorId) return false;
      const fromHash = decodeRouteHashAnchorId(route.hash);
      const effective =
        fromHash || this.mobileHomeActiveAnchorId || "section-top";
      return effective === anchorId;
    },
    onToTargetPage(menu) {
      const anchorId = this.sectionAnchorIds[menu.menu];
      if (anchorId) {
        if (this.$route.name === "Home") {
          setMobileHomeActiveSectionAnchorIdImmediate(anchorId);
          this.onCloseNavMenuHandle();
          // this.$nextTick(() => {
          //   this.scrollToAnchorById(anchorId);
          // });
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToAnchorById(anchorId);
              const el = document.getElementById(anchorId);
              if (el) {
                window.scrollTo({
                  top: el.offsetTop,
                  behavior: "smooth",
                });
              }
            }, 50);
          });
          return;
        }
        this.$router.push({ name: "Home", hash: `#${anchorId}` });
        this.onCloseNavMenuHandle();
        return;
      }
      this.$router.push({ name: menu.name });
      this.onCloseNavMenuHandle();
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-menu {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  // z-index: 9;

  &__menu {
    position: absolute;
    top: 18px;
    right: 14px;
    width: 40px;
    height: 40px;
    z-index: 99;
    cursor: pointer;
    transition: transform 0.18s ease;

    &:active {
      transform: scale(0.94);
    }
  }
  &__mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 200;
    isolation: isolate;
    // padding: 10px;
    background-color: #3c3068;
    background-image: url("@/assets/image/index/mobile_nav_bg.webp");
    background-size: cover;
    background-repeat: no-repeat;

    overflow: auto;

    &-logo {
      margin-bottom: 34px;
      padding: 10px;
      img {
        width: 128px;
        height: 54px;
      }
    }

    &-close {
      position: absolute;
      top: 18px;
      right: 14px;
      width: 40px;
      height: 40px;
      z-index: 9;
      cursor: pointer;
      transition: transform 0.18s ease;

      &:active {
        transform: scale(0.94);
      }
    }

    &-wrapper {
      position: relative;
      margin-bottom: 110px;
      padding: 94px 0 110px;
      background: rgba(0, 0, 0, 0.3);
    }

    &-content {
      display: flex;
      flex-direction: column;
      gap: 27px;
      margin-bottom: 62px;
      text-align: center;
      color: #fff;
      font-family: "Noto Sans JP", "Noto Sans", sans-serif;
      font-weight: 600;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
    }

    &-row {
      // padding: 14px 0;
      // height: 27px;
      padding: 2px 10px;
    }

    &-label {
      display: inline-block;
      padding: 4px 8px;
      border-radius: 3px;

      &--active {
        background: #fff380;
        color: #1a1530;
      }
    }

    &-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 40px;

      font-weight: 600;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
      color: #fff;

      &--wrap {
        text-decoration: none;
        color: inherit;

        &:active {
          transform: scale(0.88);
          filter: brightness(0.85);
          transition-duration: 0.06s;
        }

        &:focus-visible {
          outline: 2px solid #37fff1;
          outline-offset: 3px;
        }
      }
    }
  }
}

/* 无限滚动横幅 */
.mobile-marquee {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 60px;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  // background-image: url("@/assets/image/index/about_footer_bg.webp");
  //   background-image: url("@/assets/image/attention/header_footer_title_bg.webp");

  &--banner {
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    z-index: 2;
    background-image: url("@/assets/image/index/banner_footer_bg.webp");
  }
  &--banner &-inner {
    border-top: 2px solid #fff590;
    border-bottom: 2px solid #fff590;
  }

  &--streaming {
    position: absolute;
    bottom: -30px;
    left: 0;
    right: 0;
    z-index: 2;
    background-image: url("@/assets/image/index/about_footer_bg.webp");
  }

  &--streaming &-inner {
    border-top: 2px solid #d9a2ff;
    border-bottom: 2px solid #d9a2ff;
  }

  &-inner {
    width: 100%;
    height: 24px;
    overflow: hidden;
    background-color: #191616;
    display: flex;
    align-items: center;
  }

  &-track {
    display: flex;
    width: max-content;
    flex-shrink: 0;
    align-items: center;
    animation: mobile-marquee 30s linear infinite;
    will-change: transform;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      will-change: auto;
    }
  }

  &-group {
    display: flex;
    flex-shrink: 0;
    align-items: center;
  }

  &-title {
    flex-shrink: 0;
    margin-right: 20px;
    width: 200px;
    height: 10px;
    object-fit: contain;
    object-position: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

/* 无限滚动动画 */
@keyframes mobile-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 全屏菜单：淡入 + 轻微上浮；菜单行错峰出现（与 template 中 transition name 一致） */
.mobile-menu-enter-active,
.mobile-menu-leave-active {
  transition: opacity 0.28s ease;
}
.mobile-menu-enter-active {
  transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
}
.mobile-menu-enter,
.mobile-menu-leave-to {
  opacity: 0;
}
.mobile-menu-enter-active .mobile-menu__mask-content {
  transition: transform 0.32s cubic-bezier(0.22, 1, 0.36, 1);
}
.mobile-menu-enter .mobile-menu__mask-content {
  transform: translateY(16px);
}
.mobile-menu-leave-active .mobile-menu__mask-content {
  transition-duration: 0.2s;
}
.mobile-menu-leave-to .mobile-menu__mask-content {
  transform: translateY(-8px);
}

@keyframes mobile-nav-row-in {
  from {
    opacity: 0;
    transform: translateX(14px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.mobile-menu-enter-active .mobile-menu__mask-row {
  animation: mobile-nav-row-in 0.38s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.mobile-menu-enter-active .mobile-menu__mask-row:nth-child(1) {
  animation-delay: 0.03s;
}
.mobile-menu-enter-active .mobile-menu__mask-row:nth-child(2) {
  animation-delay: 0.06s;
}
.mobile-menu-enter-active .mobile-menu__mask-row:nth-child(3) {
  animation-delay: 0.09s;
}
.mobile-menu-enter-active .mobile-menu__mask-row:nth-child(4) {
  animation-delay: 0.12s;
}
.mobile-menu-enter-active .mobile-menu__mask-row:nth-child(5) {
  animation-delay: 0.15s;
}
.mobile-menu-enter-active .mobile-menu__mask-row:nth-child(6) {
  animation-delay: 0.18s;
}
.mobile-menu-enter-active .mobile-menu__mask-row:nth-child(7) {
  animation-delay: 0.21s;
}
.mobile-menu-enter-active .mobile-menu__mask-row:nth-child(8) {
  animation-delay: 0.24s;
}

@media (prefers-reduced-motion: reduce) {
  .mobile-menu-enter-active,
  .mobile-menu-leave-active {
    transition-duration: 0.14s;
  }
  .mobile-menu-enter-active .mobile-menu__mask-content,
  .mobile-menu-leave-active .mobile-menu__mask-content {
    transition: none;
  }
  .mobile-menu-enter .mobile-menu__mask-content,
  .mobile-menu-leave-to .mobile-menu__mask-content {
    transform: none;
  }
  .mobile-menu-enter-active .mobile-menu__mask-row {
    animation: none;
  }
  .mobile-menu__menu:active,
  .mobile-menu__mask-close:active {
    transform: none;
  }
}
</style>
